import React, { useState } from "react";
import Popup from "./PopupWithMessage";

const SendButton = ({ disabled }) => (
  <button type="submit" disabled={disabled} className="button popup-footer__button">Отправить</button>
);

const DoctorQuestionPopup = ({ name, authenticity_token, doctorId }) => {
  const [messageShown, setMessageShown] = useState(false);
  const [agreed, setAgreed] = useState(false);
  const [formDisabled, setFormDisabled] = useState(false);

  const hideMessage = () => setMessageShown(false);
  const toggleAgreement = () => setAgreed(!agreed);

  const handleSubmit = e => {
    e.preventDefault();

    setFormDisabled(true);

    const axios = require('axios');
    const url = '/questions'
    const data = new FormData(e.target);

    axios
      .post(url, data, {headers: {'Accept': 'application/json'}})
      .then(() => setMessageShown(true))
      .finally(() => {
        setFormDisabled(false);
        setAgreed(false);
      })
  };

  return (
    <form onSubmit={handleSubmit} className="new_question" id="new_question" acceptCharset="UTF-8" method="post">
      <input name="utf8" type="hidden" value="✓" />
      <input type='hidden' name='authenticity_token' value={authenticity_token} />
      <input value={doctorId} type="hidden" name="question[doctor_id]" />
      <Popup
        name={name}
        onHide={hideMessage}
        header="Задать вопрос врачу"
        footer={<SendButton disabled={formDisabled || !agreed}/>}
        message="Спасибо за вопрос!"
        messageShown={messageShown}
        hideMessage={hideMessage}
      >
        <div className="popup-description popup-description_indent-b_large">
          Доктор ответит вам в течение 2х рабочих дней.<br/>Обращаем внимание, что&nbsp;этот ответ не является консультацией.
        </div>

        <div className="popup-form">
          <div className="input-group input-group_indent-b_default">
            <label className="input-group__label" htmlFor="question_fullname">Ваше имя</label>
            <input id="question_fullname" className="input-group__input" required name="question[fullname]" />
          </div>

          <div className="input-group input-group_indent-b_default">
            <label className="input-group__label" htmlFor="question_email">Электронная почта</label>
            <input id="question_email" className="input-group__input" required name="question[email]" type="email" />
          </div>
          <div className="input-group input-group_indent-b_default">
            <label className="input-group__label" htmlFor="question_body">Вопрос</label>
            <textarea id="question_body" className="input-group__textarea" required name="question[body]" />
          </div>
          <div className="input-group">
            <label className="input-group__label input-group__label_checkbox">
              <input type="checkbox" onClick={toggleAgreement} className="input-group__checkbox" required />
              <div className="input-group__checkbox-state" />
              Выражаю согласие на обработку персональных данных в соответствии
              с условиями.
            </label>
          </div>
        </div>
      </Popup>
    </form>
  );
};

export default DoctorQuestionPopup;
